import { createAsyncThunk } from "@reduxjs/toolkit";
import walletApi from 'api/walletApi';
import { formatQueryParams } from "helpers/format";

export const getWallets = createAsyncThunk("Wallets", async (params: any = {}) => {
  try {
    const response = await walletApi.wallets(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
});

export const getAllWallets = async (params: any = {}) => {
  try {
    const response = await walletApi.getAllWallets({ page: 1, limit: 10000 });
    return response;
  } catch (error) {
    return error;
  }
};

export const getCentralWallet = async (params: any = {}) => {
  try {
    const response = await walletApi.centralWallet(formatQueryParams(params));
    return response;
  } catch (error) {
    return error;
  }
};

export const postWallet = async (data: any = {}) => {
  try {
    const response = await walletApi.postWallet(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putWallet = async (id: string | number, data: any = {}) => {
  try {
    const response = await walletApi.putWallet(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteWallet = async (id: string | number) => {
  try {
    const response = await walletApi.deleteWallet(id);
    return response;
  } catch (error) {
    return error;
  }
};

export const postSwap = async (data: any = {}) => {
  try {
    const response = await walletApi.postSwap(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const postDeposit = async (data: any = {}) => {
  try {
    const response = await walletApi.postDeposit(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const postWithdraw = async (data: any = {}) => {
  try {
    const response = await walletApi.postWithdraw(data);
    return response;
  } catch (error) {
    return error;
  }
};


export const getPositionMint = async (params: any = {}) => {
  try {
    const response = await walletApi.getPositionMint(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getPoolTokenBalance = async (params: any = {}) => {
  try {
    const response = await walletApi.getPoolTokenBalance(params)
    return response?.data;
  } catch (error) {
    return error;
  }
};


export const postBot = async (data: any = {}, type: 'WASH' | 'LIQUIDITY') => {
  try {
    const response = type === 'LIQUIDITY' ? await walletApi.postBotProvideLiquidity(data) : await walletApi.postBotTrade(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const runBot = async (id: string | number = '') => {
  try {
    const response = await walletApi.runBot(id);
    return response;
  } catch (error) {
    return error;
  }
};

export const pauseBot = async (id: string | number = '') => {
  try {
    const response = await walletApi.pauseBot(id);
    return response;
  } catch (error) {
    return error;
  }
};

export const stopBot = async (id: string | number = '') => {
  try {
    const response = await walletApi.stopBot(id);
    return response;
  } catch (error) {
    return error;
  }
};